import React, { Component, Fragment } from "react";
import Select from "./common/select";
import findContactsByCustomerCategory from "../services/customerContactsService";
import { setActiveCustomerCategory } from "../services/customersService";

class DashboardCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchResults: [],
            category: null,
            initialValuesLoaded: false
        };
    }

    componentDidMount() {
        const { category } = this.props;

        if (category) {
            this.setState({ category }, () => {
                this.fetchData();
            });
        } else {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        if (parseInt(prevProps.filterOnUserId) != parseInt(this.props.filterOnUserId) || !this.state.initialValuesLoaded) {

            this.setState({
                initialValuesLoaded: true
            }, () => {
                this.fetchData();
            });
        }
    }

    handleCategorySelect = category => {
        if (category) {
            setActiveCustomerCategory(category.id)
        }

        this.setState({
            category
        }, () => {
            this.fetchData();
        });
    }

    async fetchData() {
        let searchResults = [];
        let categoryId = -1;

        if (this.state.category) {
            categoryId = this.state.category._id ? this.state.category._id : this.state.category.id;
        }

        try {
            const response = await findContactsByCustomerCategory(categoryId, this.props.filterOnUserId);
            searchResults = response.data;
        } catch (e) { }

        this.setState({
            searchResults
        });
    };

    render() {
        const { categories } = this.props;
        const { searchResults, category } = this.state;

        return (
            <Fragment>
                <div className="col-12 mt-2">
                    <span>Kundurval</span>
                </div>
                <div className="col-12">
                    <table className="table table-itemList table--noFormGroupMargins">
                        <thead>
                            <tr>
                                <td style={{ paddingLeft: 0 }}>
                                    <Select
                                        name="customer_category_id"
                                        onChange={event => {
                                            const val = event.target.value;
                                            const index = categories.findIndex(
                                                item => item._id == val
                                            );

                                            if (index >= 0) {
                                                const selectedCategory =
                                                    categories[index];
                                                this.handleCategorySelect(
                                                    selectedCategory
                                                );
                                            } else {
                                                this.handleCategorySelect(null);
                                            }
                                        }}
                                        options={categories}
                                        value={
                                            category != null
                                                ? category.id
                                                : ""
                                        }
                                        className="flex-grow-1"
                                        hideBlankItem={true}
                                    />
                                </td>
                                <td align="right">Offerter</td>
                                <td align="right">Ordrar</td>
                                <td align="right">K.sek</td>
                            </tr>
                        </thead>
                        <tbody>
                            {searchResults.length > 0 && (
                                <Fragment>
                                    {searchResults.map(
                                        (customer, index) => (
                                            <tr key={index}>
                                                <td><a onClick={() => window.open(`/customers/${ customer.id }`)} style={{ cursor: 'pointer' }}>{customer.name}</a></td>
                                                <td align="right">
                                                    {customer.tendersCount}
                                                </td>
                                                <td align="right">
                                                    {customer.ordersCount}
                                                </td>
                                                <td align="right">
                                                    {customer.ordersValue}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </Fragment>
                            )}
                        </tbody>
                    </table>
                </div>
            </Fragment>
        );
    }
}

export default DashboardCustomer;
